module.exports = __webpack_public_path__ + "static/media/011.f5873773.jpg";